import { redirect, createFileRoute } from '@tanstack/react-router';

/**
 * The address the server hands out.
 *
 * `WG_CLIENT_PATHS.review` builds `/white-glove/tickets/:id/review`, so every
 * notification about a design ready to review points here. The page itself
 * lives one segment up; this forwards rather than duplicating it, so there is
 * one review screen no matter which link was followed.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId',
      params,
    });
  },
});
